// extracted by mini-css-extract-plugin
export default {"summary-container":"ProfessionMasterReportSummary_summary-container__YPFxa","summary-ctas":"ProfessionMasterReportSummary_summary-ctas__2dA53"};